import axios from "axios";

const request = axios.create({
  baseURL: "https://youtube.googleapis.com/youtube/v3/",
  params: {
    key: "AIzaSyDqOdZHMQEXpCtiPB7O3XYu50EjF7VYgOI",
  },
});

export default request;
